import AdManager from "./ad-manager"
import AmazonHeaderBidding from "./amazon-hb"
import Bidder from "./bidder"
import DemandManager from "./demand-manager"

class Provider {
  constructor(provider) {
    this.instance = provider
    this.loaded = false
  }

  load() {
    this.instance.load()
    this.loaded = true
  }

  refresh() {
    this.instance.refresh()
  }
}

const providers = {
  AdManager,
  AmazonHeaderBidding,
  Bidder,
  DemandManager,
}

const registry = []

const register = (provider) => {
  registry.push(new Provider(provider))
}

const load = () => {
  registry.filter((item) => !item.loaded).forEach((item) => item.load())
}

const refresh = () => {
  registry.forEach((item) => item.refresh())
}

export { register, load, refresh, providers }
